import { adminManageFilterList } from 'constants/Admin/AdminManageUserJoinPageConstants';
import { DropdownCell, DropdownLayout } from './DropdownForms';
import { adminSearchFilterList, manageFilterList, mindUpAllReservationSearchFilterList, searchFilterList } from 'constants/diagnosisListPageConstants';
import { adminAssessmentPaymentSearchFilterList, CLManagingPatientSearchFilterList, CLPatientInfoChartFilterList, CLUserLookupSearchFilterList } from 'pages/Admin/CL/constants';
import { PeriodFilterDropdownProps } from 'models/Hospital/diagnosisListPageTypes';

const SearchFilterDropdownNotPeriod = ({ selectedSearchFilter, handleDropdown, type }: PeriodFilterDropdownProps) => {
    const divideDropdownList = (type?: string) => {
        switch (type) {
            case 'mindUpAllReservation':
                return mindUpAllReservationSearchFilterList;
            case 'adminManageUserJoinPage':
                return adminManageFilterList;
            case 'mindupTodayDiagnosis':
            case 'managingPatients':
                return manageFilterList;
            case 'admin':
                return adminSearchFilterList;
            case 'CLPatientInfoChartFilterList':
                return CLPatientInfoChartFilterList;
            case 'clManagingPatients':
                return CLManagingPatientSearchFilterList;
            case 'clUserLookup':
                return CLUserLookupSearchFilterList;
            case 'adminAssessmentPaymentPage':
                return adminAssessmentPaymentSearchFilterList;
            default:
                return searchFilterList;
        }
    };

    const divideDropdownHeight = (type?: string) => {
        switch (type) {
            case 'adminManageUserJoinPage':
                return '118px';
            case 'mindupTodayDiagnosis':
            case 'managingPatients':
            case 'mindUpAllReservation':
                return '154px';
            case 'clManagingPatients':
                return '118px';
            case 'clUserLookup':
                return '154px';
            case 'adminAssessmentPaymentPage':
                return '118px';
            default:
                return '188px';
        }
    };

    return (
        <DropdownLayout $position='absolute' $height={divideDropdownHeight(type)} $padding='4px 0' $top='44px' $left='0'>
            {divideDropdownList(type).map((item, idx) => {
                return (
                    <DropdownCell key={idx} $height='36px' $padding='8px 12px' onClick={(e: React.MouseEvent) => handleDropdown(e, idx, 'search')} $selected={selectedSearchFilter === idx}>
                        {item}
                    </DropdownCell>
                );
            })}
        </DropdownLayout>
    );
};

export default SearchFilterDropdownNotPeriod;
